import React, { useState } from 'react';
import { useLogin } from './LoginContext';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import LogoNova from '../../logos/LogoNova.svg';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Select, MenuItem, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Cookies from 'universal-cookie';
import { Logout, CreditCard } from 'tabler-icons-react';
import TarjetasView from './TarjetasView';
import '../../styles/tarjetas.css';

export default function Config() {
    const [showTarjetas, setShowTarjetas] = useState(false);
    const {
        selectLine,
        selectCelda,
        lines,
        handleChangeLine,
        handleChangeCelda,
        infoUser,
        setConfigView,
        setIsConfig,
        setInfoUser,
        setOpenA,
        setOpenB,
        filterCell,
        card1,
        setCard1,
        login,
        setLogin,
        auto,
        setAuto,
        count,
        setCount,
        andon,
        setAndon,
    } = useLogin();

    let color = '';

    if (process.env.REACT_APP_THEME === 'tecnoTheme') {
        color = '#eb7d1e';
    } else if (process.env.REACT_APP_THEME === 'posTheme') {
        color = '#00638D';
    } else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
        color = '#001F66';
    } else {
        color = '#4c2e7f';
    }

    const handleClickConf = (e) => {
        e.preventDefault();
        const cookie = new Cookies();

        if (selectLine !== '') {
            const current = new Date();
            const nextYear = new Date();
            nextYear.setFullYear(current.getFullYear() + 1);
            setOpenA(false);
            setOpenB(true);
        
            const selectedLineObj = lines.find((line) => line.id === parseInt(selectLine));
        
            if (selectedLineObj) {
                cookie.set('linea', selectLine, { path: '/', expires: nextYear });
                cookie.set('nombreL', selectedLineObj.nombre, { path: '/', expires: nextYear });
                cookie.set('card', card1, { path: '/', expires: nextYear });
                cookie.set('login', login, { path: '/', expires: nextYear });
                cookie.set('auto', auto, { path: '/', expires: nextYear });
                cookie.set('count', count, { path: '/', expires: nextYear });
                cookie.set('andon', andon, { path: '/', expires: nextYear });
                cookie.set('celda', selectCelda, { path: '/', expires: nextYear });
        
                setConfigView(false);
                setIsConfig(false);
            } else {
                console.error('Línea seleccionada no encontrada en el arreglo "lines"');
            }
        } else {
            setOpenA(true);
        }
        
    };

    return (
        <div>
            <div className="login-wrapper-form-titles">
                <img
                    src={LogoNova}
                    className="config-wrapper-form-titles-novalogo"
                    alt="tsr-logo"
                />
                <p className="config-wrapper-form-titles-title">Panel de configuración</p>
                <p className="config-wrapper-form-titles-subtitle">
                    Usuario: {infoUser.nombre} {infoUser.apellido}
                </p>
            </div>

            <div className="config-line">
                <FormControl className="config-selectLine">
                    <InputLabel id="line-label">Seleccione una Línea</InputLabel>
                    <Select
                        labelId="line-label"
                        id="line"
                        value={lines.length > 0 ? selectLine : ''}
                        onChange={(e) => handleChangeLine(e)}
                    >
                        {Array.isArray(lines) &&
                            lines.map((linea) => (
                                <MenuItem value={linea.id} key={linea.id}>
                                    {linea.nombre}
                                </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="config-line">
                <FormControl className="config-selectLine">
                    <InputLabel id="celda-label">Seleccione una Celda</InputLabel>
                    <Select
                        labelId="celda-label"
                        id="celda"
                        value={filterCell.length > 0 ? selectCelda : ''}
                        onChange={(e) => handleChangeCelda(e)}
                    >
                        {Array.isArray(filterCell) &&
                            filterCell.map((celda) => (
                                <MenuItem value={celda.celda1} key={celda.celda1}>
                                    {celda.nombre}
                                </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="config">
                <List>
                    <ListItem className="config-list">
                        <ListItemText id="card" primary="Autenticación con tarjeta" />
                        <Switch
                            edge="end"
                            onChange={(e) => {
                                setCard1(e.target.checked);
                            }}
                            name="card"
                            checked={card1}
                            inputProps={{
                                'aria-labelledby': 'switch-list-label-card',
                            }}
                        />
                    </ListItem>
                    <ListItem className="config-list">
                        <ListItemText id="login" primary="Autenticación con Login" />
                        <Switch
                            edge="end"
                            onChange={(e) => setLogin(e.target.checked)}
                            checked={login}
                            name="login"
                            inputProps={{
                                'aria-labelledby': 'switch-list-label-login',
                            }}
                        />
                    </ListItem>
                    <ListItem className="config-list">
                        <ListItemText id="auto" primary="Adquisición de datos automaticos" />
                        <Switch
                            edge="end"
                            onChange={(e) => setAuto(e.target.checked)}
                            checked={auto}
                            name="auto"
                            inputProps={{
                                'aria-labelledby': 'switch-list-label-auto',
                            }}
                        />
                    </ListItem>
                    <ListItem className="config-list" disabled={auto}>
                        <ListItemText id="count" primary="Conteo piezas malas por ciclo" />
                        <Switch
                            edge="end"
                            onChange={(e) => setCount(e.target.checked)}
                            checked={count}
                            name="count"
                            inputProps={{
                                'aria-labelledby': 'switch-list-label-count',
                            }}
                        />
                    </ListItem>
                    <ListItem className="config-list">
                        <ListItemText id="andon" primary="Mostrar botones ANDON" />
                        <Switch
                            edge="end"
                            onChange={(e) => setAndon(e.target.checked)}
                            checked={andon}
                            name="andon"
                            inputProps={{ 'aria-labelledby': 'switch-list-label-andon' }}
                        />
                    </ListItem>
                </List>
            </div>
            <div className="config-button-field">
                <Button
                    variant="outlined"
                    className="login-button"
                    color="primary"
                    startIcon={<CreditCard size={18} />}
                    onClick={() => setShowTarjetas(true)}
                >
                    Gestionar Tarjetas
                </Button>
            </div>
            <div className="config-button-field config-button-field--separated">
                <Button
                    variant="contained"
                    className="login-button"
                    color="primary"
                    onClick={(e) => handleClickConf(e)}
                >
                    Guardar
                </Button>
            </div>
            <div className="config-wrapper-config">
                <Button
                    className="login-wrapper-config-button"
                    variant="contained"
                    onClick={(e) => {
                        setConfigView(false);
                        setIsConfig(false);
                        setInfoUser([]);
                    }}
                >
                    <Logout size={25} color={color} />
                    <div className="login-wrapper-config-button-text">
                        Regresar a la página de ingreso
                    </div>
                </Button>
            </div>

            <Dialog
                open={showTarjetas}
                onClose={() => setShowTarjetas(false)}
                PaperProps={{ className: 'tarjetas-dialog-paper' }}
                maxWidth={false}
            >
                <TarjetasView onBack={() => setShowTarjetas(false)} />
            </Dialog>
        </div>
    );
}
